import "./App.css";
import NoMatch from "./pages/NoMatch";
import { Route, Routes } from "react-router-dom";
import Layout from "./components/Layout";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import HomePage from "./pages/HomePage";
import ProductPage from "./pages/ProductPage";
import CartPage from "./pages/CartPage";
import CategoryPage from "./pages/CategoryPage";
import CheckOutPage from "./pages/CheckOutPage";
import SalePage from "./pages/SalePage";
import CustomerOrdersPage from "./pages/CustomerOrdersPage";
import CustomerOrderViewPage from "./pages/CustomerOrderViewPage";
import PrivateRoute from "./components/PrivateRoute";
import CustomerEditDataPage from "./pages/CustomerEditDataPage";
import AboutThisProjectPage from "./pages/AboutThisProjectPage";
import CustomerPage from "./pages/CustomerPage";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <div className="d-flex flex-column position-relative h-100 animate__animated animate__fadeIn">
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />

        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route
            path="/about-this-project"
            element={<AboutThisProjectPage />}
          />
          <Route path="/product/:productName" element={<ProductPage />} />
          <Route path="/category/:categorySlug" element={<CategoryPage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/products/:sale" element={<SalePage />} />
          <Route
            path="/customers/:firstname/profile"
            element={<PrivateRoute element={<CustomerPage />} />}
          />
          <Route
            path="/customers/:firstname/orders"
            element={<PrivateRoute element={<CustomerOrdersPage />} />}
          />
          <Route
            path="/customers/:firstname/orders/:id"
            element={<PrivateRoute element={<CustomerOrderViewPage />} />}
          />
          <Route
            path="/customers/:firstname/settings"
            element={<PrivateRoute element={<CustomerEditDataPage />} />}
          />
        </Route>
        <Route
          path="/checkout"
          element={<PrivateRoute element={<CheckOutPage />} />}
        />
        <Route path="*" element={<NoMatch />} />
      </Routes>
      <ToastContainer
        position="top-right"
        autoClose={2500}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default App;
